"use client";

import { useEffect } from "react";

import { saveOfflineSnapshot, type OfflineSnapshot } from "@/lib/offline-snapshot";

export function OfflineSnapshotWriter({ snapshot }: { snapshot: OfflineSnapshot | null }) {
  useEffect(() => {
    if (!snapshot || !navigator.onLine) return;
    saveOfflineSnapshot(window.localStorage, snapshot);
  }, [snapshot]);
  return null;
}
